import { DictionariesService } from '@services/DictionariesService';
import { cachedDictionaryScheme, peekDictionaryScheme } from '@services/dictionaryCache';
import { IDictionaryGridScheme } from '@models/dictionary/IDictionaryDetailedItems';

const schemeKey = (dictName: string, isFormData: boolean) => `${isFormData ? 'formdata' : 'dict'}:${dictName}`;

/** Схема справочника (атрибуты, глубина дерева) для пикера — из кэша сессии. */
export const loadDictScheme = (dictName: string, isFormData: boolean): Promise<IDictionaryGridScheme> =>
    cachedDictionaryScheme(schemeKey(dictName, isFormData), () =>
        (isFormData
            ? DictionariesService.fetchFormdataDictionaryGridScheme(dictName)
            : DictionariesService.fetchDictionaryGridScheme(dictName)
        ).then((response) => response.data),
    );

/** Схема из кэша сессии, если уже загружена. */
export const peekDictScheme = (dictName: string, isFormData: boolean) =>
    peekDictionaryScheme<IDictionaryGridScheme>(schemeKey(dictName, isFormData));
